import React, { useEffect, useState } from 'react';

const Button = (props) => {
    let id = null;
    let callBackFunc = null;
    let data = null;
    let info = null;
    // console.log('is it worked',this)
    props.data == undefined ? data = {} : data = props.data;
    props.info ==  undefined ? info = JSON.stringify({}) : info = JSON.stringify(props.info);
    // console.log('Button props.data', props.data)
    props.clickFunction == undefined ? callBackFunc = e => {} : callBackFunc = (event) => props.clickFunction(event, data);
    props.btnId == undefined ?  id =  parseInt(Math.random()*1000) : id = props.btnId;

    

    return(
        <>
            <button id={id} className={props.classList} onMouseDown={callBackFunc} data-info={info}>{props.children}</button>
        </>
    )
} 

export default Button;